import { useRouter } from 'next/router';

import ProductDetailPage from 'productTemplate/components/ProductDetailPage';
import { getPdpServerSideProps } from 'shared/utils/getPdpServerSideProps';
import {
  IConsumerSearchFactsWindowData,
  IRelatedProductData,
} from 'productTemplate/types/FactsWindowData';
import { IFeaturedInCollection } from 'productTemplate/types/FeaturedInCollection';
import { IGmcOffers } from 'shared/types/Offer';
import { IProductTemplate } from 'shared/types/ProductTemplate';
import { LOCALES } from 'localization/constants/configEnums';
import { Error } from 'error/components/Error';
import { ProductDetailPageHead } from 'productTemplate/components/ProductDetailPageHead';

interface IProductDetailPage {
  country: string;
  factsWindowData: IConsumerSearchFactsWindowData;
  featuredInCollections: IFeaturedInCollection[];
  isCrawler: boolean;
  isMobileUserAgent: boolean;
  errorCode?: number;
  errorMessage?: string;
  locale?: LOCALES;
  offers: IGmcOffers;
  productTemplate: IProductTemplate;
  recommendedProducts: Array<IRelatedProductData>;
}

const SneakersPDP = ({
  factsWindowData,
  featuredInCollections,
  isCrawler = false,
  isMobileUserAgent,
  errorCode,
  errorMessage,
  locale,
  offers,
  productTemplate,
  recommendedProducts,
}: IProductDetailPage) => {
  const { asPath } = useRouter();
  let refetchedProductTemplate: IProductTemplate;

  if (errorCode) {
    return <Error errorCode={errorCode} errorMessage={errorMessage} />;
  }

  return (
    <>
      <ProductDetailPageHead
        locale={locale}
        offers={offers}
        productTemplate={productTemplate}
        productTypeFromUrl={asPath?.split('/')?.[1]}
      />
      <ProductDetailPage
        factsWindowData={factsWindowData}
        featuredInCollections={featuredInCollections}
        isCrawler={isCrawler}
        isMobileUserAgent={isMobileUserAgent}
        locale={locale}
        offers={offers}
        productTemplate={refetchedProductTemplate || productTemplate}
        recommendedProducts={recommendedProducts}
      />
    </>
  );
};

export async function getServerSideProps({ query, req, res, locale }) {
  return getPdpServerSideProps({ query, req, res, locale });
}

export default SneakersPDP;
